import { greenCircleIcon, plusIcon, yellowCircleIcon, greyCircleIcon, editIcon } from '../../utils/images';
import './SensorsStatus.scss';
import { Sensor } from '../../types/Sensor';
import { useState } from 'react';
import { AssignLocationForm } from '../AssignLocationForm';
import { Location } from '../../types/Locations';

interface SensorsStatusProps {
  sensors: Sensor[];
  locations: Location[];
  onRefresh: () => void;
}

const getStatusIcon = (status: string) => {
  switch (status) {
    case "active":
      return greenCircleIcon;
    case "fault":
      return yellowCircleIcon;
    default:
      return greyCircleIcon;
  }
};

export const SensorsStatus: React.FC<SensorsStatusProps> = ({ sensors, locations, onRefresh }) => {
  const [isAssignFormOpen, setIsAssignFormOpen] = useState(false);
  const [selectedSensor, setSelectedSensor] = useState<Sensor | null>(null);

  const handleEditClick = (sensor: Sensor) => {
    setSelectedSensor(sensor);
    setIsAssignFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsAssignFormOpen(false);
    setSelectedSensor(null);
  };

  const handleAssignSuccess = () => {
    onRefresh();
  };

  return (
    <>
      <div className="status">
        <div className="status-header">
          <div className="status-header--title">
            <h2 className="status-header--text">Sensor Status</h2>
          </div>
          
          <div className="status-legend">
            <div className="status-indicators">
              <img src={greenCircleIcon} alt="Icon" />
              <span className="status-indicator active">Active</span>
              <img src={yellowCircleIcon} alt="Icon" />
              <span className="status-indicator fault">Fault</span>
              <img src={greyCircleIcon} alt="Icon" />
              <span className="status-indicator inactive">Inactive</span>
            </div>
          </div>
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr className="status-table__row">
                <th className="status-table__header">Location</th>
                <th className="status-table__header">Type</th>
                <th className="status-table__header">Mac address</th>
                <th className="status-table__header">Id</th>
                <th className="status-table__header status-table__header-edit"></th>
              </tr>
            </thead>
            <tbody>
              {sensors.map((sensor) => (
                <tr className="status-table__row-body" key={sensor.id}>
                  <td className="status-table__cell">
                    <div className="status-table__cell-container">
                      <img src={getStatusIcon(sensor.sensor_status)} alt="Status Icon" />
                      {sensor.location_code || 'Not assigned'}
                    </div>
                  </td>
                  <td className="status-table__cell">{sensor.sensor_type}</td>
                  <td className="status-table__cell">{sensor.mac_address}</td>
                  <td className="status-table__cell">{sensor.id}</td>
                  <td className="status-table__cell status-table__cell-edit">
                    <img 
                      src={editIcon} 
                      alt="Edit icon" 
                      onClick={() => handleEditClick(sensor)}
                      style={{ cursor: 'pointer' }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {selectedSensor && (
        <AssignLocationForm
          isOpen={isAssignFormOpen}
          onClose={handleCloseForm}
          locations={locations}
          item={selectedSensor}
          itemType="sensor"
          onSuccess={handleAssignSuccess}
        />
      )}
    </>
  );
};